<template>
    <van-dialog
        :value="value"
        :title="title"
        show-cancel-button
        cancel-button-text="取消"
        confirm-button-text="保存"
        :before-close="beforeClose"
        class="remark-dialog"
        :confirmButtonColor="'#0072f5'"
        @input="$emit('input', $event)"
    >
        <span class="title">
            {{ tip }}
        </span>
        <van-field
            v-model="remark"
            class="no-need-remark"
            type="text"
            autosize
            :placeholder="placeholder"
        />
    </van-dialog>
</template>

<script>
// 「无需」二次确认弹窗，备注非必填
export default {
  name: 'NoNeedDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '如有问题，可在此处填写备注信息'
    },

    // 点击保存后的处理函数，返回 Promise<Boolean>，返回 false 时保持弹窗不关闭
    handler: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      remark: ''
    }
  },
  watch: {
    value (val) {
      if (!val) this.remark = ''
    }
  },
  methods: {
    beforeClose (action, done) {
      // 取消：关闭弹窗，不提交数据，单选框保持原选中状态
      if (action !== 'confirm') {
        done()
        return
      }
      const remark = (this.remark || '').trim()
      if (remark.length > Number(this.maxlength)) {
        this.$toast(`备注最多输入${this.maxlength}字`)
        done(false)
        return
      }
      if (!this.handler) {
        done()
        return
      }
      Promise.resolve(this.handler(remark))
        .then(result => done(result === false ? false : undefined))
        .catch(() => done(false))
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .no-need-remark {
    margin: 0.49rem 0.66rem 0.66rem;
    width: auto;

    border-radius: 0.26rem;
    padding: 0.41rem;
    background: #f3f3f4 !important;
}
.title {
    color: #535d6d;
    font-size: 0.5rem !important;
    width: 100%;
    display: flex;
    margin-top: 0.2rem;
    justify-content: center;
}
</style>
<style lang="scss" >
::v-deep .remark-dialog {
    .van-dialog__confirm {
        color: #0072f5 !important;
    }

    .van-dialog__header {
        font-size: 0.57rem !important;
    }
}
</style>
